import HappyFace from '../../images/Icons/happy-face-icon.svg';
import DeliveryTruck from '../../images/Icons/delivery-truck.svg';
import Paw from '../../images/Icons/paw-icon.svg';

export const callouts = [
  {
    icon: HappyFace,
    text: 'Happiness guaranteed',
    viewBox: '0 0 22 21',
    width: HappyFace.width,
    height: HappyFace.height,
  },
  {
    icon: DeliveryTruck,
    text: 'Flexible delivery',
    viewBox: '0 0 24 24',
    width: DeliveryTruck.width,
    height: DeliveryTruck.height,
  },
  {
    icon: Paw,
    text: 'Pause or Cancel anytime',
    viewBox: '0 0 50 42',
    width: '29',
    height: '24',
  },
];
